import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../context/AuthProvider";
import { landingPathFor } from "../utils/roles";

// The /home index used to render the Dashboard directly. Org accounts have no
// dashboard permission, so landing there — on login, on refresh, or by typing
// /home — showed them the "no access" screen. Send each account to its own
// first page instead.
const HomeIndexRedirect = () => {
  const { accessToken } = useAuth();

  let role;
  let orgId;
  try {
    const decoded = jwtDecode(accessToken);
    role = decoded?.role;
    orgId = decoded?.orgId;
  } catch (e) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={landingPathFor(role, orgId)} replace />;
};

export default HomeIndexRedirect;
